import React, { useState, useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

import { Languages } from '../../constants';
import { useApplicationParams, useLanguage } from '../../context';
import BackHeader from '../layout/BackHeader';
import Icons from '../../constants/Icons';

const OrdersManagement = () => {
  const [orders, setOrders] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const { t } = useTranslation();

  const { appVersion, platform, deviceId, userToken } = useApplicationParams();
  const { language, isRtl } = useLanguage();

  useEffect(() => {
    const cancelToken = axios.CancelToken.source();

    const getOrders = async () => {
      try {
        setIsLoading(true);

        const response = await axios.get(`${process.env.REACT_APP_API_URL}/shopv2/orders`, {
          headers: {
            'Content-Type': 'application/json',
            'x-api-version': appVersion || '4.11.1',
            'x-api-key': process.env.REACT_APP_API_KEY,
            'x-api-os': platform || 'android',
            'x-user-lang': language || Languages.English,
            'x-api-device-id': deviceId || 'CBC64810-FF0C-4008-9558-A999C18085E7',
            authorization: userToken || '',
          },
          cancelToken: cancelToken.token,
        });

        if (response.data.status === 'success') {
          setOrders(response.data.data);
        }
      } finally {
        setIsLoading(false);
      }
    };

    getOrders();

    return () => {
      cancelToken.cancel();
    };
  }, [language, userToken]);

  return (
    <>
      <BackHeader title={t('orders')} />
      <section dir={isRtl ? 'rtl' : 'ltr'} className="handle-fixed-nav">
        {isLoading && <div className="loader mt-5" />}
        {!isLoading && orders && orders.length === 0 && (
          <div className="text-center">
            <img src={Icons.noOrderss} className="no-orders-img" alt="" />
            <p className="no-orders-text">{t('no_orders')}</p>
          </div>
        )}
        {!isLoading &&
          orders.map((orderItem) => (
            <div className="order-card" key={orderItem.id}>
              <p className="order-date">
                {t('bought_on')}
                {` ${orderItem.date.split('-')[2]}-${orderItem.date.split('-')[1]}-${
                  orderItem.date.split('-')[0]
                }`}
              </p>
              <div className="order-content">
                <Row>
                  <Col xs={3} className="px-2">
                    <div className="text-center">
                      <img
                        src={orderItem.productDetails.backgroundImageURL}
                        className="order-product-img"
                        alt=""
                      />
                    </div>
                  </Col>
                  <Col xs={8} className="px-2">
                    <div className="order-product-div1">
                      <p className="order-product-name">{orderItem.productDetails.name}</p>
                    </div>
                    {!isRtl ? (
                      <div className="order-product-div2">
                        {orderItem.productDetails.attributes?.size && (
                          <span className="order-size-span">
                            {orderItem.productDetails.attributes.size.toUpperCase()}
                          </span>
                        )}
                        {orderItem.method === 'points' ? (
                          <span className="order-price">
                            <img src={Icons.diamond} className="order-diamond-img" alt="" />
                            {orderItem.cost}
                          </span>
                        ) : (
                          <span className="order-price">${orderItem.cost}</span>
                        )}
                        {orderItem.isVip && (
                          <span className="vip-badge-order">
                            <img src={Icons.crown} alt="vip" className="vip-badge-img-order" />
                            VIP
                          </span>
                        )}
                      </div>
                    ) : (
                      <div className="order-product-div2">
                        {orderItem.method === 'points' ? (
                          <span className="order-price mr-1">
                            <img src={Icons.diamond} className="order-diamond-img" alt="" />
                            {orderItem.cost}
                          </span>
                        ) : (
                          <span className="order-price mr-1">${orderItem.cost}</span>
                        )}
                        {orderItem.isVip && (
                          <span className="vip-badge-order">
                            <img src={Icons.crown} alt="vip" className="vip-badge-img-order" />
                            VIP
                          </span>
                        )}
                        {orderItem.productDetails.attributes &&
                          orderItem.productDetails.attributes.size && (
                            <span className="order-size-span">
                              {orderItem.productDetails.attributes.size.toUpperCase()}
                            </span>
                          )}
                      </div>
                    )}
                    <div className="order-product-div3">
                      <span
                        className={`order-badge ${orderItem.status === 'placed' && 'blue'} ${
                          orderItem.status === 'shipped' && 'red'
                        } ${orderItem.status === 'delivered' && 'green'} ${
                          orderItem.status === 'Cancelled' && 'red'
                        }`}
                      >
                        {t(orderItem.status)}
                      </span>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          ))}
      </section>
    </>
  );
};

export default OrdersManagement;
